// behavior libraries
import {
  ButtonBase,
  Container,
  dispatcher,
  ingenuity,
  ITween,
  Linear,
  SpineBase,
} from "@quest/base-core";
import { ButtonBaseBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BaseCore/ButtonBaseBehavior";

// Internal constants and models
import { eventDispatchers } from "../../Constants/EventDispatchers";

// Local views and behaviors
import { ReSpinIntroOutroView } from "../View/ReSpinIntroOutroView";
import { MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { gameConstants } from "../../Constants/gameConstants";
import { GameParserModel } from "../../Platform/GameParserModel";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";

export class ReSpinIntroOutroController {
  protected view: ReSpinIntroOutroView;
  private continueButton: ButtonBaseBehavior;
  private reSpinIntroMainContainer: Container;
  private reSpinIntroBgContainer: Container;
  private continueButtonContainer: Container;

  private reSpinIntroCharContainer: Container;

  private reSpinIntroBg: SpineBase;
  private reSpinIntroFish: SpineBase;
  private reSpinOutroMainContainer: Container;
  private reSpinOutroBgContainer: Container;
  private reSpinOutroCharContainer: Container;
  private respinsCompleteContainer: Container;

  private reSpinOutroBg: SpineBase;
  private reSpinOutroFish: SpineBase;

  constructor(view: ReSpinIntroOutroView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvent();
  }

  /**
   * method initializeElements: initialize elements to class components.
   */
  private initializeElements(): void {
    this.reSpinIntroMainContainer = this.view.getContainerByID("reSpinIntroMainContainer");
    this.reSpinIntroBgContainer = this.view.getContainerByID("reSpinIntroBgContainer");
    this.reSpinIntroCharContainer = this.view.getContainerByID("reSpinIntroCharContainer");
    this.reSpinIntroBg = this.reSpinIntroBgContainer.children[0] as SpineBase;
    this.reSpinIntroFish = this.reSpinIntroCharContainer.children[0] as SpineBase;
    this.reSpinOutroMainContainer = this.view.getContainerByID("reSpinOutroMainContainer");
    this.reSpinOutroBgContainer = this.view.getContainerByID("reSpinOutroBgContainer");
    this.reSpinOutroCharContainer = this.view.getContainerByID("reSpinOutroCharContainer");
    this.reSpinOutroBg = this.reSpinOutroBgContainer.children[0] as SpineBase;
    this.continueButtonContainer = this.view.getContainerByID("ContinueButtonContainer");
    this.reSpinOutroFish = this.reSpinOutroCharContainer.children[0] as SpineBase;
    this.continueButton = this.view.getButtonById("continueButton") as ButtonBaseBehavior;
    this.respinsCompleteContainer = this.view.getContainerByID("respinsCompleteContainer");
  }

  /**
   * Subscribe events
   */
  private subscribeEvent(): void {
    this.unSubscribeEvent();
    dispatcher.on(eventDispatchers.START_RESPIN_INTRO, this.startRespinIntro, this);
    dispatcher.on(eventDispatchers.START_RESPIN_OUTRO, this.startOutro, this);
    dispatcher.on(eventDispatchers.ADD_RESPIN_INTRO_OUTRO_ON_TOP, this.view.addViewToTop, this.view);

  }

  /**
   * Unsubscribe events
   */
  private unSubscribeEvent(): void {
    dispatcher.off(eventDispatchers.START_RESPIN_INTRO, this.startRespinIntro, this);
    dispatcher.off(eventDispatchers.START_RESPIN_OUTRO, this.startOutro, this);
    dispatcher.off(eventDispatchers.ADD_RESPIN_INTRO_OUTRO_ON_TOP, this.view.addViewToTop, this.view);

  }
  /**
   * to show respin intro
   */
  private startRespinIntro(): void {
    this.view.addViewToTop();
    this.continueButton.off(ButtonBase.UP, this.onContinuePressUpOutro, this);
    this.continueButton.off(ButtonBase.UP, this.onContinuePressUpNoWinOutro, this);
    this.continueButton.on(ButtonBase.UP, this.onContinuePressUp, this);
    this.reSpinIntroMainContainer.visible = true;

    this.continueButton.visible = true;
    this.continueButton.disableAndTint();

    this.startIntroAnim();
  }



  /**
   * function to play intro spine animation
   */
  private startIntroAnim(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.FISH_TIME_INTRO_BLURBG_SHOW);
    // dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER);
    this.startIntroBgAnims();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitIntroAnims();
    this.startIntroFishAnims();
    this.view.getContainerByID("taptoclickMessage").alpha = 0;
    this.view.getContainerByID("taptoclickMessage").visible = true;
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.getContainerByID("taptoclickMessage"))
      .to({ alpha: 1 }, 500, Linear.None, true, 500, 0, false);
    alphaTween.onComplete.addOnce(() => {
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
      this.continueButton.enableAndTint();
    }, this);
  }

  protected playPortraitIntroAnims(): void {
    const portraitBg = this.view.getSpineById("Fishing_Time_Intro_bg_portrait");
    portraitBg.playAnim("fishing_time_intro_bg_effect_portrait", false);
    portraitBg.onComplete.addOnce(() => {
      portraitBg.playAnim("fishing_time_intro_loop_bg_portrait", true);
    })
  }

  protected startIntroBgAnims(): void {
    this.reSpinIntroBgContainer.visible = true;
    this.reSpinIntroBg.visible = true;
    (ingenuity.soundManager as any).playSound(SoundConstantGame.RESPINS_START, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    this.reSpinIntroBg.playAnim("fishing_time_intro_bg_effect_desktop", false);
    this.reSpinIntroBg.onComplete.addOnce(() => {
      this.reSpinIntroBg.playAnim("fishing_time_intro_loop_bg_desktop", true);
    }, this);
  }

  protected startIntroFishAnims(): void {
    this.reSpinIntroCharContainer.visible = true;
    this.reSpinIntroFish.visible = true;
    this.reSpinIntroFish.playAnim("fishing_time_intro_in_fg", false);
    this.reSpinIntroFish.onComplete.addOnce(() => {
      this.reSpinIntroFish.playAnim("fishing_time_intro_loop_fg", true);
    }, this);
  }

  private onContinuePressUp(): void {
    this.continueButton.disableAndTint();
    this.hidePlayerMessage();
    this.continueButton.visible = false;
    this.reSpinIntroBg.playAnim("fishing_time_intro_out_bg_desktop", false);
    this.reSpinIntroFish.playAnim("fishing_time_intro_out_fg", false);

    this.reSpinIntroFish.onComplete.addOnce(() => {
      this.reSpinIntroMainContainer.visible = false;
      this.reSpinIntroBg.visible = false;
      this.reSpinIntroFish.visible = false;
      // dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER);
      dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
    }, this);
  }

  private onContinuePressUpOutro(): void {
    this.continueButton.disableAndTint();
    this.hidePlayerMessage();
    this.continueButton.visible = false;
    this.endReSpinOutro();

    this.fadeOutroBanner();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitOutroEndAnims();
  }
  private onContinuePressUpNoWinOutro(): void {
    this.continueButton.disableAndTint();
    this.hidePlayerMessage();
    this.resetOutroBanner();
    this.continueButton.visible = false;
  }

  private hidePlayerMessage(): void {
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.getContainerByID("taptoclickMessage"))
      .to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      this.view.getContainerByID("taptoclickMessage").visible = false;
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
    }, this);
  }
  /**
   * show outro presentation
   */
  private startOutro(): void {
    this.view.addViewToTop();
    // dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO_ON_BANNER);
    this.continueButton.off(ButtonBase.UP, this.onContinuePressUp, this);
    this.reSpinOutroMainContainer.visible = true;
    if ((ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin() > 0) {
      this.continueButton.on(ButtonBase.UP, this.onContinuePressUpOutro, this);
      this.startOutroBgAnims();
      !ingenuity.deviceEnv.isDesktop && this.playPortraitOutroAnims();
      this.startOutroFishAnims();
      this.youWonWithFadeIn();
    } else {
      this.continueButton.on(ButtonBase.UP, this.onContinuePressUpNoWinOutro, this);
      this.continueButton.alpha = 1;
      this.view.getContainerByID("taptoclickMessage").visible = true;
      this.continueButton.visible = true;
      this.continueButton.enableAndTint();
      this.respinsCompleteContainer.visible = true;
    }
  }
  protected playPortraitOutroAnims(): void {
    const portraitBg = this.view.getSpineById("Fishing_Time_Outro_bg_portrait");
    portraitBg.playAnim("fishing_time_outro_in_bg_portrait", false);
    portraitBg.onComplete.addOnce(() => {
      portraitBg.playAnim("fishing_time_outro_loop_bg_portrait", true);
    })
  }
  protected playPortraitOutroEndAnims(): void {
    const portraitBg = this.view.getSpineById("Fishing_Time_Outro_bg_portrait");
    portraitBg.playAnim("fishing_time_outro_out_bg_portrait", false);
  }
  protected startOutroBgAnims(): void {
    this.reSpinOutroBgContainer.visible = true;
    this.reSpinOutroBg.visible = true;
    (ingenuity.soundManager as any).playSound(SoundConstantGame.RESPINS_YOU_WON, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    this.reSpinOutroBg.playAnim("fishing_time_outro_in_bg_desktop", false);
    this.reSpinOutroBg.onComplete.addOnce(() => {
      this.reSpinOutroBg.playAnim("fishing_time_outro_loop_bg_desktop", true);
    });
  }

  protected startOutroFishAnims(): void {
    this.reSpinOutroCharContainer.visible = true;
    this.reSpinOutroFish.visible = true;
    this.reSpinOutroFish.playAnim("fishing_time_outro_in_fg", false);
    this.reSpinOutroFish.onComplete.addOnce(() => {
      this.reSpinOutroFish.playAnim("fishing_time_outro_loop_fg", true);
    });
  }


  /**
   * Method to fade in jackpot win banner.
   */
  private youWonWithFadeIn(): void {
    this.view.outroTextMainContainer.alpha = 0;
    this.view.outroTextMainContainer.visible = true;
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.outroTextMainContainer)
      .to({ alpha: 1 }, 500, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      alphaTween.stop();
      this.startYouWonOutroTickup();
      ingenuity.currentGame.tweens.remove(alphaTween);
    }, this);
  }
  /**
   * function to start outro tickup
   */
  private startYouWonOutroTickup(): void {
    const jackpotWinMeter = this.view.getMeterById("OutroWinAmount") as MeterBehavior;
    jackpotWinMeter.visible = true;
    const amount = (ingenuity.parserModel as GameParserModel).getFishingTimeTotalWin();;
    jackpotWinMeter.startTick(amount, true, false, 2, true, () => {
      this.view.addChild(this.continueButtonContainer);
      this.view.getContainerByID("taptoclickMessage").alpha = 0.7;
      this.view.getContainerByID("taptoclickMessage").visible = true;
      const alphaTween: ITween = ingenuity.currentGame.add
        .tween(this.view.getContainerByID("taptoclickMessage"))
        .to({ alpha: 1 }, 300, Linear.None, true, 0, 0, false);
      alphaTween.onComplete.addOnce(() => {
        alphaTween.stop();
        ingenuity.currentGame.tweens.remove(alphaTween);
      }, this);
      this.continueButton.visible = true;
      this.continueButton.enableAndTint();
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
    });
  }
  /**
   * fadeOutroBanner to fade jp banners
   */
  private fadeOutroBanner(): void {
    const amountFadeOutTween: ITween = ingenuity.currentGame.add
      .tween(this.view.outroTextMainContainer)
      .to({ alpha: 0 }, 100, Linear.None, true, 0, 0, false);
    amountFadeOutTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(amountFadeOutTween);
    }, this);
  }
  /**
   * function to play respin outro anim
   */

  private endReSpinOutro(): void {
    const outroBg = new Promise<void>((resolve) => {
      this.reSpinOutroBg.playAnim("fishing_time_outro_out_bg_desktop", false);
      this.reSpinOutroBg.onComplete.addOnce(() => {
        resolve();
      });
    });
    const outroFg = new Promise<void>((resolve) => {
      this.reSpinOutroFish.playAnim("fishing_time_outro_out_fg", false);
      this.reSpinOutroFish.onComplete.addOnce(() => {
        resolve();
      });
    });
    Promise.all([outroBg, outroFg])
      .then(() => {
        this.resetOutroBanner();
      })
      .catch((error) => {
        console.error("Error with animations:", error);
      });
  }

  /**
   * resetOutroBanner to reset jackpot containers
   */
  private resetOutroBanner(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    this.reSpinOutroBg.visible = false;
    this.reSpinOutroFish.visible = false;
    this.respinsCompleteContainer.visible = false;
    // dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER);
    dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);
  }
  public resetController(): void {
    this.unSubscribeEvent()
    this.continueButton.off(ButtonBase.UP, this.onContinuePressUpOutro, this);
    ingenuity.currentGame.tweens.removeFrom(this)
  }
}
